import React from 'react';
import { Modal } from 'react-bootstrap';
import websiteImage from './../../images/website.png'
import './ShowMenu.css'
import config from './../../config.json';

const ShowMenuModal = ({ showModal, handleClose, customer }) => {



    return (
        <Modal
            size="lg"
            show={showModal}
            onHide={handleClose}
            aria-labelledby="example2234-modal-sizes-title-sm"
            backdrop="static"
            className='menu-modal-layer'
            animation={false}
        >
            <Modal.Title id="license234-modal-sizes-title-sm"
                className='rtl d-flex align-items-center ml-auto m-0 w-100'>
                <img src={websiteImage} alt="" style={{ width: "40px", marginLeft: '10px' }} />
                {customer && customer.companyName}
                <button className='btn btn-white ml-auto' onClick={handleClose}>
                    <i className='fa fa-times' style={{fontSize:'1.5rem'}}></i>
                </button>
            </Modal.Title>
            {
                customer &&
                <Modal.Body className='rtl p-0' style={{height:'90vh'}}>
                    <iframe
                        src={`${config.server_address.split('/api/')[0]}/online/${String(customer.companyName).toLowerCase()}`}
                        width="100%"
                        height="100%"
                        title="PDF Viewer"
                        name={`${Date.now()}`}
                    />
                </Modal.Body>
            }
        </Modal>
    );
}

export default ShowMenuModal;